import { User } from 'types';
import { i18n } from 'i18next';

import transformData from 'modules/_shared/components/Tables/helpers';
import {
  AdministratedListData,
  AdministratedListResponse,
} from 'modules/society/types/AdministratedList';

import tableColumns from './administratedListTableColumns';

type MapAdministratedDataToTableProps = {
  data: AdministratedListResponse;
  user: User;
  i18n: i18n;
  isDemo: boolean;
};

export const mapAdministratedDataToTable = ({
  data,
  user,
  i18n,
  isDemo,
}: MapAdministratedDataToTableProps): AdministratedListData => {
  if (!data || data.length === 0) return [];

  const parsedData = data?.map((item) => ({
    society: item.society,
    name: item.society.name,
    partners: item.partnersCount,
    value: item.societyValue,
    creationDate: item.society.creationDate,
    isAdmin: true,
    isDemo,
    user,
  }));

  const transformedData = transformData({
    data: parsedData,
    columns: tableColumns(i18n),
  });

  return transformedData;
};
